export const orderStatusLabels = {
  new: "New",
  fullFilled: "FullFilled",
  paid: "Paid",
  cancelled: "Cancelled",
};
